import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

// Строки интерфейса. Ключ отсутствует в it → берётся ru.
const DICT = {
  ru: {
    'menu.home': '🏠 Главная',
    'menu.donate': '❤️ Поддержка',
    'menu.course': '📘 Курс',
    'menu.study': '🇮🇹 Занятие',
    'menu.progress': '📈 Прогресс',
    'menu.reading': '📖 Чтение',
    'menu.account': '👤 Аккаунт',
    'menu.admin': '🛠️ Админ',
    'menu.login': '🔐 Войти',
    'menu.register': '✍️ Регистрация',
    'menu.bug': '🐞 Сообщить об ошибке',
    'bug.title': '🐞 Сообщить об ошибке',
    'bug.hint': 'Опишите, что пошло не так и что вы ожидали. Страница, язык и браузер прикрепятся сами.',
    'bug.cardHint': 'Что не так с этой карточкой? Вопрос, правильный ответ и ваш ответ прикрепятся сами.',
    'bug.placeholder': 'Например: в слове «молоко» не то ударение…',
    'bug.email': 'Ваш email (если хотите получить ответ)',
    'bug.send': 'Отправить',
    'bug.cancel': 'Отмена',
    'bug.close': 'Закрыть',
    'bug.thanks': 'Спасибо! Сообщение отправлено.',
    'bug.error': 'Не удалось отправить. Попробуйте ещё раз или напишите на boris@shbb.pro.',
    'bug.limit': 'Слишком много сообщений за час — попробуйте позже.',
    'bug.cardLink': '🐞 Ошибка в карточке?',

    'auth.email': 'Email',
    'auth.password': 'Пароль',
    'auth.confirmPassword': 'Подтвердите пароль',
    'auth.name': 'Имя',
    'auth.emailRequired': 'Email обязателен',
    'auth.emailInvalid': 'Некорректный email',
    'auth.passwordRequired': 'Пароль обязателен',
    'auth.passwordShort': 'Пароль должен содержать минимум 6 символов',
    'auth.passwordMismatch': 'Пароли не совпадают',
    'auth.nameRequired': 'Имя обязательно',
    'auth.registerError': 'Ошибка регистрации',
    'auth.notVerified': 'Пожалуйста, подтвердите ваш email. Проверьте вашу почту для получения ссылки подтверждения.',
    'auth.wrongCredentials': 'Неверный email или пароль',
    'auth.loginTitle': 'Вход',
    'auth.loginButton': 'Войти',
    'auth.registerTitle': 'Регистрация',
    'auth.registerButton': 'Зарегистрироваться',
    'auth.forgot': 'Забыли пароль?',
    'auth.noAccount': 'Нет аккаунта? Зарегистрироваться',
    'auth.haveAccount': 'Уже есть аккаунт? Войти',
    'auth.agree': 'Регистрируясь, вы соглашаетесь с',
    'auth.terms': 'условиями использования',
    'auth.language': 'Язык интерфейса',
    'auth.waitTitle': 'Подтвердите email',
    'auth.waitText': 'Мы отправили письмо со ссылкой подтверждения на {email}.',
    'auth.waitSpam': 'Если вы не видите письмо, пожалуйста, проверьте папку «Спам».',
    'confirm.title': 'Подтверждение email',
    'confirm.checking': 'Проверяем ваш код…',
    'confirm.success': 'Email успешно подтвержден!',
    'confirm.canLogin': 'Теперь вы можете войти в свой аккаунт.',
    'confirm.toLogin': 'Перейти к входу',
    'confirm.errorTitle': 'Ошибка подтверждения.',
    'confirm.errorText': 'Возможно, ссылка устарела или код неверен. Попробуйте зарегистрироваться снова или напишите на boris@shbb.pro.',
    'confirm.invalidTitle': 'Неверная ссылка.',
    'confirm.invalidText': 'Убедитесь, что вы скопировали полную ссылку из письма.',

    'account.title': 'Личный кабинет',
    'account.welcome': 'Добро пожаловать в ваш личный кабинет!',
    'account.voice': '⚙️ Настройки голоса',
    'account.support': '❤️ Поддержать проект',
    'account.theme': 'Тема оформления',
    'account.dark': 'Темная',
    'account.light': 'Светлая',
    'account.changePassword': 'Сменить пароль',
    'account.currentPassword': 'Текущий пароль',
    'account.newPassword': 'Новый пароль',
    'account.confirmNewPassword': 'Подтвердите новый пароль',
    'account.save': 'Сохранить',
    'account.logout': '🚪 Выйти из аккаунта',
    'account.passwordsMismatch': 'Новые пароли не совпадают',
    'account.passwordChanged': 'Пароль успешно изменен',
    'account.passwordError': 'Не удалось изменить пароль. Проверьте текущий пароль.',

    'study.title': 'Sessione di oggi',
    'study.streak': '🔥 Серия: {n} дн.',
    'study.due': 'К повторению: {n}',
    'study.todayMinutes': 'Сегодня: {m} из {goal} мин',
    'study.reviewOld': '🔁 Повторение из урока {n} — потом продолжим урок {cur}.',
    'study.sayIn.it': 'Скажи по-итальянски:',
    'study.sayIn.ru': 'Скажи по-русски:',
    'study.catchUp': '↩️ Недоученное из урока {n} — потом продолжим урок {cur}.',
    'course.alphabet': 'Весь алфавит',
    'course.alphabet.letter': 'Буква',
    'course.alphabet.latin': 'Латиница',
    'course.alphabet.sound': 'Как звучит',
    'study.currentLesson': '📘 Текущий урок: {n}. {title}',
    'study.plan': 'Сегодня: повторить {due} · новых до {new}',
    'study.noNewToday': 'Дневной лимит новых карточек выбран — сейчас будут только повторения.',
    'study.plusFive': '+5 новых',
    'study.goalText': 'Цель — {goal} минут активных занятий. Таймер идёт только пока ты отвечаешь и останавливается, если отвлечься.',
    'study.start': 'Iniziamo!',
    'study.toProgress': '📈 Прогресс',
    'study.toCourse': '📘 Курс и грамматика',
    'study.bravo': 'Bravo! 🎉',
    'study.endTitle': 'Fine sessione',
    'study.timeOf': 'Время: {t} из {goal} мин',
    'study.answersOf': 'Ответов: {n}, верно {p}%',
    'study.streakLine': '🔥 Серия: {n} дн.',
    'study.again': 'Ещё одно занятие',
    'study.finish': 'Завершить',
    'study.allDone': 'На сейчас всё повторено 👌',
    'study.nextReview': 'Следующее повторение: {d}',
    'study.moreNew': 'Выучить ещё 5 новых',
    'study.finishSession': 'Завершить занятие',
    'study.new': 'новое',
    'study.mine': 'мой словарь',
    'study.lesson': '📘 Урок {n}',
    'study.howToSay.it': 'Как по-итальянски:',
    'study.howToSay.ru': 'Как по-русски:',
    'study.read': '🔤 Чтение · Как это читается?',
    'study.readChip': '🔤 чтение',
    'study.readHint': 'Переводить не нужно: напишите латиницей, как произносится слово (мама → mama). Знак ´ — ударение.',
    'study.readPlaceholder': 'как читается… (mama)',
    'study.readOk': 'Верно! Читается так:',
    'study.readWrong': 'Читается так:',
    'study.letters': 'По буквам:',
    'study.drill': 'Преобразуй:',
    'study.placeholder': 'ответ…',
    'study.check': 'Проверить',
    'study.dontKnow': 'Не знаю',
    'study.verdict.exact': 'Esatto!',
    'study.verdict.translit': 'Верно! Кириллицей:',
    'study.verdict.accent': 'Почти — проверь ударение',
    'study.verdict.typo': 'Опечатка, но засчитано',
    'study.verdict.synonym': 'С {verb} тоже верно, но здесь тренируем {target}:',
    'study.verdict.partial': 'Почти — посмотри, где ошибка:',
    'study.tableTitle': 'Заполни всю таблицу по порядку лиц:',
    'study.tableLearn': 'Новая таблица — прочитай вслух несколько раз сверху вниз:',
    'study.tableMemorized': 'Запомнил — проверить себя',
    'study.tableAux': 'вспомогательный глагол — {aux}',
    'study.auxTitle': 'Сложные времена: с каким вспомогательным глаголом?',
    'study.auxBoth': 'оба',
    'study.auxExample': 'Пример: io {ex}',
    'study.auxReason.reflexive': 'Возвратный глагол (-rsi, по-русски обычно на -ся) → всегда essere: mi sono alzato, ti saresti sbrigato.',
    'study.auxReason.essere': 'Движение, состояние или изменение без дополнения → essere: sono andato, è nata, sarebbe venuto.',
    'study.auxReason.avere': 'Обычный глагол, особенно переходный (что? кого?) → avere: ho fatto, avrei detto.',
    'study.auxReason.dual': 'Подходят оба: с дополнением — avere (ho finito il lavoro), без — essere (il film è finito).',
    'study.auxReason.weather': 'Погода — можно и так, и так: è piovuto / ha piovuto.',
    'study.verdict.wrong': 'Правильно так:',
    'study.speak': 'Произнести',
    'study.knewIt': 'Я знал (опечатка)',
    'study.knewItNote': 'Засчитано как верный',
    'study.wasHard': 'Было трудно',
    'study.wasHardNote': 'Отмечено как трудное',
    'study.tooEasy': 'Слишком легко',
    'study.tooEasyNote': 'Отмечено как лёгкое',
    'study.next': 'Дальше ↵',
    'study.newLesson': 'Новый урок · {level}',
    'study.lessonTitle': 'Урок {n}. {title}',
    'study.willConjugate': 'Будем спрягать: {verbs} — {tenses}.',
    'study.toExercises': 'Понятно, к упражнениям',
    'study.gotIt': 'Понятно',
    'study.almostTitle': 'Ещё чуть-чуть?',
    'study.almostText': 'До цели осталось {m} мин. Серия засчитывается от 5 минут, но цель — {goal}.',
    'study.finishAnyway': 'Всё равно завершить',
    'study.continue': 'Продолжаю',
    'study.goalReached': '🎉 Цель на сегодня выполнена! Можно продолжать.',
    'study.errLoadProgress': 'Не удалось загрузить прогресс',
    'study.errStart': 'Не удалось начать занятие',
    'study.errCards': 'Не удалось загрузить карточки',
    'study.errAnswer': 'Ошибка при отправке ответа',
    'study.errRating': 'Не удалось изменить оценку',
    'study.meaning': 'Значение: {m}',

    'progress.title': 'Il mio progresso',
    'progress.studyNow': 'Заниматься',
    'progress.streak': 'Серия',
    'progress.streakHint': 'дни от 5 минут',
    'progress.today': 'Сегодня',
    'progress.known': 'Знаю твёрдо',
    'progress.knownHint': 'изучается {l}, к повторению {d}',
    'progress.accuracy': 'Точность',
    'progress.accuracy30': 'за 30 дней {p}',
    'progress.minutesPerDay': 'Минуты в день',
    'progress.goalLine': 'цель {goal}',
    'progress.daysAgo': '30 дней назад',
    'progress.todayAxis': 'сегодня',
    'progress.tooltip': '{d}: {m} мин, ответов {n}',
    'progress.tooltipCorrect': ', верно {p}%',
    'progress.chartLabel': 'Минуты занятий за 30 дней. Цель {goal} минут в день.',
    'progress.level': 'Оценка уровня',
    'progress.levelEmpty': 'Пока оценок нет. Раз в неделю Маэстро будет анализировать твои ответы и записывать сюда уровень по областям и комментарий — так будет видна динамика.',
    'progress.tenses': 'Времена глаголов',
    'progress.tense': 'Время',
    'progress.correct': 'Верно',
    'progress.solid': 'Твёрдо',
    'progress.lessons': 'Уроки',
    'progress.lessonStats': '{i}/{t} · твёрдо {k}',
    'progress.settings': 'Настройки занятий',
    'progress.goal': 'Цель, минут в день',
    'progress.newPerDay': 'Новых элементов в день',
    'progress.whatToStudy': 'Что учить',
    'progress.course.petrov': 'Итальянский: курс (Петров + продолжение)',
    'progress.course.russo': 'Русский для итальянцев',
    'progress.course.personal': 'Мой словарь',
    'progress.openUpTo': 'Открыт курс до урока',
    'progress.openUpToHint': 'Уроки открываются сами, когда пройден предыдущий. Можно перескочить вперёд.',
    'progress.showOnBoard': 'Показывать меня на доске почёта',
    'progress.uiLang': 'Язык интерфейса',
    'progress.save': 'Сохранить',
    'progress.saved': '✓ Сохранено',
    'progress.error': 'Не удалось загрузить прогресс',

    'course.title': 'Курс',
    'course.lessons': 'Уроки',
    'course.mine': 'Мой словарь',
    'course.intro': 'Уроки открываются по мере прохождения. Слова и спряжения открытых уроков попадают в ежедневное занятие.',
    'course.current': 'текущий',
    'course.conjugations': 'Спряжения: {tenses}',
    'course.words': 'Слова',
    'course.phrases': 'Фразы',
    'course.reading': 'Чтение',
    'course.drills': 'Упражнения',
    'course.startLesson': '▶ Начать этот урок',
    'course.studyNow': '▶ Заниматься',
    'course.noCourse': 'Курс не выбран — выберите его в «Прогресс → Настройки».',
    'course.target.it': 'По-итальянски (лемма или выражение)',
    'course.target.ru': 'По-русски',
    'course.native.it': 'Перевод на итальянский',
    'course.native.ru': 'Перевод',
    'course.note': 'Заметка / пример (необязательно)',
    'course.add': 'Добавить',
    'course.addError': 'Не удалось добавить',
    'course.duplicate': 'Это слово уже есть в вашем словаре',
    'course.delete': 'Удалить',
    'course.oldMode': 'Старый режим:',
    'course.oldCards': 'карточки',
    'course.oldWords': 'словарь',
    'course.loadError': 'Не удалось загрузить курс',
    'course.loadDictError': 'Не удалось загрузить словарь',

    'voice.title': 'Выберите голос',
    'voice.lang.it': 'Итальянский',
    'voice.lang.ru': 'Русский',
    'voice.hint': 'Голос берётся из системы телефона или компьютера. Выбранный голос используется в занятиях.',
    'voice.missing.it': 'На устройстве нет итальянского голоса. iPhone: Настройки → Универсальный доступ → Устный контент → Голоса → Итальянский. Android: Настройки → Синтез речи (Google) → Установить голосовые данные → Итальянский. Компьютер: добавьте итальянский язык в систему (или используйте Chrome) и перезапустите браузер.',
    'voice.missing.ru': 'На устройстве нет русского голоса. iPhone: Настройки → Универсальный доступ → Устный контент → Голоса → Русский. Android: Настройки → Синтез речи (Google) → Установить голосовые данные → Русский. Компьютер: добавьте русский язык в систему (или используйте Chrome) и перезапустите браузер.',
    'voice.textTitle': 'Введите текст для произношения',
    'voice.rate': 'Скорость: {v}',
    'voice.pitch': 'Высота: {v}',
    'voice.speak': 'Произнести текст',
    'voice.setDefault': 'Установить голос по умолчанию',
    'voice.saved': '✓ Голос «{name}» установлен по умолчанию',
    'study.listen': 'Послушать',
    'study.noVoice': 'На этом устройстве нет голоса для озвучки — откройте «Аккаунт → Настройки голоса», там инструкция.',

    'board.title': '🏆 Доска почёта',
    'board.study': 'Заниматься →',
    'board.today': 'Сегодня',
    'board.week': '7 дней',
    'board.emptyToday': 'Сегодня ещё никто не занимался — стань первым!',
    'board.emptyWeek': 'За неделю пока пусто.',
    'board.you': ' (ты)',
    'board.min': '{m} мин',
    'board.yourPlace': 'Ты на {r}-м месте ({m} мин).',
    'board.gap': ' До пятёрки — {g} мин.',
    'board.join': 'Позанимайся от минуты — и попадёшь в рейтинг.',
    'board.note': 'Считаются активные минуты в «Занятии». Видно только участникам; скрыть себя можно в «Прогресс → Настройки».',
    'board.student': 'Ученик',
  },
  it: {
    'menu.home': '🏠 Home',
    'menu.donate': '❤️ Sostieni',
    'menu.course': '📘 Corso',
    'menu.study': '🇷🇺 Lezione',
    'menu.progress': '📈 Progressi',
    'menu.reading': '📖 Lettura',
    'menu.account': '👤 Account',
    'menu.admin': '🛠️ Admin',
    'menu.login': '🔐 Accedi',
    'menu.register': '✍️ Registrati',
    'menu.bug': '🐞 Segnala un problema',
    'bug.title': '🐞 Segnala un problema',
    'bug.hint': "Descrivi cosa non ha funzionato e cosa ti aspettavi. Pagina, lingua e browser vengono allegati da soli.",
    'bug.cardHint': 'Cosa non va in questa scheda? Domanda, risposta giusta e la tua risposta vengono allegate da sole.',
    'bug.placeholder': "Per esempio: nella parola «молоко» l'accento è sbagliato…",
    'bug.email': 'La tua email (se vuoi una risposta)',
    'bug.send': 'Invia',
    'bug.cancel': 'Annulla',
    'bug.close': 'Chiudi',
    'bug.thanks': 'Grazie! Messaggio inviato.',
    'bug.error': 'Invio non riuscito. Riprova o scrivi a boris@shbb.pro.',
    'bug.limit': "Troppi messaggi nell'ultima ora: riprova più tardi.",
    'bug.cardLink': '🐞 Errore in questa scheda?',

    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.confirmPassword': 'Conferma la password',
    'auth.name': 'Nome',
    'auth.emailRequired': "L'email è obbligatoria",
    'auth.emailInvalid': 'Email non valida',
    'auth.passwordRequired': 'La password è obbligatoria',
    'auth.passwordShort': 'La password deve avere almeno 6 caratteri',
    'auth.passwordMismatch': 'Le password non coincidono',
    'auth.nameRequired': 'Il nome è obbligatorio',
    'auth.registerError': 'Errore di registrazione',
    'auth.notVerified': "Conferma la tua email: controlla la posta, ti abbiamo inviato un link.",
    'auth.wrongCredentials': 'Email o password errate',
    'auth.loginTitle': 'Accedi',
    'auth.loginButton': 'Accedi',
    'auth.registerTitle': 'Registrazione',
    'auth.registerButton': 'Registrati',
    'auth.forgot': 'Password dimenticata?',
    'auth.noAccount': 'Non hai un account? Registrati',
    'auth.haveAccount': 'Hai già un account? Accedi',
    'auth.agree': 'Registrandoti accetti le',
    'auth.terms': "condizioni d'uso",
    'auth.language': "Lingua dell'interfaccia",
    'auth.waitTitle': "Conferma l'email",
    'auth.waitText': 'Ti abbiamo inviato una email con il link di conferma a {email}.',
    'auth.waitSpam': 'Se non la trovi, controlla la cartella «Spam».',
    'confirm.title': "Conferma dell'email",
    'confirm.checking': 'Stiamo verificando il codice…',
    'confirm.success': 'Email confermata!',
    'confirm.canLogin': 'Ora puoi accedere al tuo account.',
    'confirm.toLogin': 'Vai ad accedere',
    'confirm.errorTitle': 'Conferma non riuscita.',
    'confirm.errorText': 'Forse il link è scaduto o il codice non è corretto. Prova a registrarti di nuovo o scrivi a boris@shbb.pro.',
    'confirm.invalidTitle': 'Link non valido.',
    'confirm.invalidText': "Controlla di aver copiato il link completo dall'email.",

    'account.title': 'Il mio account',
    'account.welcome': 'Benvenuto nel tuo account!',
    'account.voice': '⚙️ Impostazioni voce',
    'account.support': '❤️ Sostieni il progetto',
    'account.theme': 'Tema',
    'account.dark': 'Scuro',
    'account.light': 'Chiaro',
    'account.changePassword': 'Cambia password',
    'account.currentPassword': 'Password attuale',
    'account.newPassword': 'Nuova password',
    'account.confirmNewPassword': 'Conferma la nuova password',
    'account.save': 'Salva',
    'account.logout': "🚪 Esci dall'account",
    'account.passwordsMismatch': 'Le nuove password non coincidono',
    'account.passwordChanged': 'Password cambiata',
    'account.passwordError': 'Impossibile cambiare la password. Controlla la password attuale.',

    'study.title': 'Урок дня · La lezione di oggi',
    'study.streak': '🔥 Serie: {n} gg.',
    'study.due': 'Da ripassare: {n}',
    'study.todayMinutes': 'Oggi: {m} di {goal} min',
    'study.reviewOld': '🔁 Ripasso della lezione {n} — poi continui con la lezione {cur}.',
    'study.sayIn.it': 'Dillo in italiano:',
    'study.sayIn.ru': 'Dillo in russo:',
    'study.catchUp': '↩️ Recupero dalla lezione {n} (non l\'avevi finita) — poi continui con la lezione {cur}.',
    'course.alphabet': "L'alfabeto completo",
    'course.alphabet.letter': 'Lettera',
    'course.alphabet.latin': 'Latino',
    'course.alphabet.sound': 'Come si pronuncia',
    'study.currentLesson': '📘 Lezione attuale: {n}. {title}',
    'study.plan': 'Oggi: {due} da ripassare · fino a {new} nuove',
    'study.noNewToday': 'Hai già imparato tutte le cose nuove previste per oggi: ora ci sono solo ripassi.',
    'study.plusFive': '+5 nuove',
    'study.goalText': "L'obiettivo è {goal} minuti di studio attivo. Il timer conta solo mentre rispondi e si ferma se ti distrai.",
    'study.start': 'Начнём! · Iniziamo!',
    'study.toProgress': '📈 Progressi',
    'study.toCourse': '📘 Corso e grammatica',
    'study.bravo': 'Молоде́ц! 🎉',
    'study.endTitle': 'Fine della lezione',
    'study.timeOf': 'Tempo: {t} di {goal} min',
    'study.answersOf': 'Risposte: {n}, corrette {p}%',
    'study.streakLine': '🔥 Serie: {n} gg.',
    'study.again': "Un'altra lezione",
    'study.finish': 'Termina',
    'study.allDone': 'Per ora hai ripassato tutto 👌',
    'study.nextReview': 'Prossimo ripasso: {d}',
    'study.moreNew': 'Impara altre 5 cose nuove',
    'study.finishSession': 'Termina la lezione',
    'study.new': 'nuovo',
    'study.mine': 'il mio dizionario',
    'study.lesson': '📘 Lezione {n}',
    'study.howToSay.it': 'Come si dice in italiano:',
    'study.howToSay.ru': 'Come si dice in russo:',
    'study.read': '🔤 Lettura · Come si legge?',
    'study.readChip': '🔤 lettura',
    'study.readHint': "Non serve tradurre: scrivi in lettere latine come si pronuncia la parola (мама → mama). Il segno ´ indica l'accento.",
    'study.readPlaceholder': 'come si legge… (es. mama)',
    'study.readOk': 'Giusto! Si legge così:',
    'study.readWrong': 'Si legge così:',
    'study.letters': 'Lettera per lettera:',
    'study.drill': 'Trasforma:',
    'study.placeholder': 'risposta… / ответ…',
    'study.check': 'Controlla',
    'study.dontKnow': 'Non lo so',
    'study.verdict.exact': 'Пра́вильно! Giusto!',
    'study.verdict.translit': 'Giusto! In cirillico:',
    'study.verdict.accent': "Quasi — controlla l'accento",
    'study.verdict.typo': 'Errore di battitura, ma vale',
    'study.verdict.synonym': 'Anche con {verb} va bene, ma qui alleniamo {target}:',
    'study.verdict.partial': 'Quasi — guarda dove hai sbagliato:',
    'study.tableTitle': 'Completa tutta la tabella, persona per persona:',
    'study.tableLearn': 'Tabella nuova — leggila ad alta voce un paio di volte:',
    'study.tableMemorized': "L'ho imparata — verifica",
    'study.tableAux': 'ausiliare — {aux}',
    'study.auxTitle': 'Tempi composti: quale ausiliare?',
    'study.auxBoth': 'tutti e due',
    'study.auxExample': 'Esempio: io {ex}',
    'study.verdict.wrong': 'La risposta giusta:',
    'study.speak': 'Pronuncia',
    'study.knewIt': 'Lo sapevo (errore di battitura)',
    'study.knewItNote': 'Contata come giusta',
    'study.wasHard': 'Era difficile',
    'study.wasHardNote': 'Segnata come difficile',
    'study.tooEasy': 'Troppo facile',
    'study.tooEasyNote': 'Segnata come facile',
    'study.next': 'Avanti ↵',
    'study.newLesson': 'Nuova lezione · {level}',
    'study.lessonTitle': 'Lezione {n}. {title}',
    'study.willConjugate': 'Coniugheremo: {verbs} — {tenses}.',
    'study.toExercises': 'Ho capito, agli esercizi',
    'study.gotIt': 'Ho capito',
    'study.almostTitle': 'Ancora un po\'?',
    'study.almostText': "All'obiettivo mancano {m} min. La serie conta da 5 minuti, ma l'obiettivo è {goal}.",
    'study.finishAnyway': 'Termina comunque',
    'study.continue': 'Continuo',
    'study.goalReached': "🎉 Obiettivo di oggi raggiunto! Puoi continuare.",
    'study.errLoadProgress': 'Impossibile caricare i progressi',
    'study.errStart': 'Impossibile iniziare la lezione',
    'study.errCards': 'Impossibile caricare le schede',
    'study.errAnswer': "Errore nell'invio della risposta",
    'study.errRating': 'Impossibile cambiare la valutazione',
    'study.meaning': 'Significa: {m}',

    'progress.title': 'I miei progressi',
    'progress.studyNow': 'Studia',
    'progress.streak': 'Serie',
    'progress.streakHint': 'giorni da 5 minuti',
    'progress.today': 'Oggi',
    'progress.known': 'So bene',
    'progress.knownHint': 'in studio {l}, da ripassare {d}',
    'progress.accuracy': 'Precisione',
    'progress.accuracy30': 'in 30 giorni {p}',
    'progress.minutesPerDay': 'Minuti al giorno',
    'progress.goalLine': 'obiettivo {goal}',
    'progress.daysAgo': '30 giorni fa',
    'progress.todayAxis': 'oggi',
    'progress.tooltip': '{d}: {m} min, risposte {n}',
    'progress.tooltipCorrect': ', corrette {p}%',
    'progress.chartLabel': 'Minuti di studio negli ultimi 30 giorni. Obiettivo {goal} minuti al giorno.',
    'progress.level': 'Valutazione del livello',
    'progress.levelEmpty': 'Ancora nessuna valutazione. Qui comparirà la valutazione del tuo livello nel tempo.',
    'progress.tenses': 'Tempi verbali',
    'progress.tense': 'Tempo',
    'progress.correct': 'Giuste',
    'progress.solid': 'Sicuri',
    'progress.lessons': 'Lezioni',
    'progress.lessonStats': '{i}/{t} · sicuri {k}',
    'progress.settings': 'Impostazioni',
    'progress.goal': 'Obiettivo, minuti al giorno',
    'progress.newPerDay': 'Elementi nuovi al giorno',
    'progress.whatToStudy': 'Cosa studiare',
    'progress.course.petrov': 'Italiano: corso Petrov (per russofoni)',
    'progress.course.russo': 'Russo per italiani',
    'progress.course.personal': 'Il mio dizionario',
    'progress.openUpTo': 'Corso aperto fino alla lezione',
    'progress.openUpToHint': 'Le lezioni si aprono da sole quando finisci la precedente. Puoi anche saltare avanti.',
    'progress.showOnBoard': "Mostrami nell'albo d'onore",
    'progress.uiLang': "Lingua dell'interfaccia",
    'progress.save': 'Salva',
    'progress.saved': '✓ Salvato',
    'progress.error': 'Impossibile caricare i progressi',

    'course.title': 'Corso',
    'course.lessons': 'Lezioni',
    'course.mine': 'Il mio dizionario',
    'course.intro': 'Le lezioni si aprono man mano. Parole e coniugazioni delle lezioni aperte entrano nella lezione quotidiana.',
    'course.current': 'attuale',
    'course.conjugations': 'Coniugazioni: {tenses}',
    'course.words': 'Parole',
    'course.phrases': 'Frasi',
    'course.reading': 'Lettura',
    'course.drills': 'Esercizi',
    'course.startLesson': '▶ Inizia questa lezione',
    'course.studyNow': '▶ Studia',
    'course.noCourse': 'Nessun corso scelto: sceglilo in «Progressi → Impostazioni».',
    'course.target.it': 'In italiano',
    'course.target.ru': 'In russo (cirillico)',
    'course.native.it': 'Traduzione in italiano',
    'course.native.ru': 'Traduzione',
    'course.note': 'Nota / esempio (facoltativo)',
    'course.add': 'Aggiungi',
    'course.addError': 'Impossibile aggiungere',
    'course.duplicate': 'Questa parola è già nel tuo dizionario',
    'course.delete': 'Elimina',
    'course.oldMode': 'Vecchia modalità:',
    'course.oldCards': 'schede',
    'course.oldWords': 'dizionario',
    'course.loadError': 'Impossibile caricare il corso',
    'course.loadDictError': 'Impossibile caricare il dizionario',

    'voice.title': 'Scegli la voce',
    'voice.lang.it': 'Italiano',
    'voice.lang.ru': 'Russo',
    'voice.hint': 'La voce è quella del sistema del telefono o del computer. La voce scelta viene usata nelle lezioni.',
    'voice.missing.it': 'Sul dispositivo non c\'è una voce italiana. iPhone: Impostazioni → Accessibilità → Contenuti letti ad alta voce → Voci → Italiano. Android: Impostazioni → Sintesi vocale (Google) → Installa dati vocali → Italiano. Computer: aggiungi l\'italiano alle lingue del sistema (o usa Chrome) e riavvia il browser.',
    'voice.missing.ru': 'Sul dispositivo non c\'è una voce russa. iPhone: Impostazioni → Accessibilità → Contenuti letti ad alta voce → Voci → Russo. Android: Impostazioni → Sintesi vocale (Google) → Installa dati vocali → Russo. Computer: aggiungi il russo alle lingue del sistema (o usa Chrome) e riavvia il browser.',
    'voice.textTitle': 'Scrivi un testo da pronunciare',
    'voice.rate': 'Velocità: {v}',
    'voice.pitch': 'Tono: {v}',
    'voice.speak': 'Pronuncia il testo',
    'voice.setDefault': 'Usa questa voce',
    'voice.saved': '✓ Voce «{name}» impostata',
    'study.listen': 'Ascolta',
    'study.noVoice': 'Su questo dispositivo manca la voce per la pronuncia: apri «Account → Impostazioni voce», lì trovi le istruzioni.',

    'board.title': "🏆 Albo d'onore",
    'board.study': 'Studia →',
    'board.today': 'Oggi',
    'board.week': '7 giorni',
    'board.emptyToday': 'Oggi non ha ancora studiato nessuno: sii il primo!',
    'board.emptyWeek': 'Questa settimana ancora niente.',
    'board.you': ' (tu)',
    'board.min': '{m} min',
    'board.yourPlace': 'Sei al {r}° posto ({m} min).',
    'board.gap': ' Ai primi cinque mancano {g} min.',
    'board.join': 'Studia almeno un minuto per entrare in classifica.',
    'board.note': "Contano i minuti attivi nella «Lezione». Visibile solo agli iscritti; puoi nasconderti in «Progressi → Impostazioni».",
    'board.student': 'Studente',
  },
};

export const LANGS = ['ru', 'it'];

// По умолчанию русская версия. Язык браузера не учитываем: у русскоязычных в Италии он почти всегда
// итальянский. Итальянскую версию включают явно («Imparo il russo») — выбор запоминается.
function initialLang() {
  try {
    const saved = localStorage.getItem('uiLang');
    if (LANGS.includes(saved)) return saved;
  } catch (e) {
    // localStorage недоступен — остаёмся на русском
  }
  return 'ru';
}

const LangContext = createContext({ lang: 'ru', setLang: () => {}, t: (k) => k });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(initialLang);

  const setLang = useCallback((next) => {
    if (!LANGS.includes(next)) return;
    try { localStorage.setItem('uiLang', next); } catch (e) { /* не критично */ }
    setLangState(next);
  }, []);

  const t = useCallback((key, vars) => {
    const template = DICT[lang]?.[key] ?? DICT.ru[key] ?? key;
    if (!vars) return template;
    return template.replace(/\{(\w+)\}/g, (_, name) => (vars[name] ?? ''));
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
export const useT = () => useContext(LangContext).t;
